// The rail's 30px pill select (approved mockup ".railrow select"): shared by
// the three property controls so they can't drift apart by a pixel.
export const railSelectClass =
  'h-[30px] max-w-[220px] rounded-etn-pill border border-etn-border-hairline bg-etn-surface px-3 text-etn-control font-semibold text-etn-text-cell disabled:opacity-50'
